"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HlAppointmentRequestModel = exports.AppointmentDayPreferenceModel = void 0;
const validator_1 = require("@leavy/validator");
const AppointmentRequest_1 = require("../domain/appointment-request/AppointmentRequest");
class AppointmentDayPreferenceModel {
    constructor() {
        this.times = [];
    }
}
__decorate([
    (0, validator_1.IsEnum)(AppointmentRequest_1.AppointmentWeekDay),
    __metadata("design:type", String)
], AppointmentDayPreferenceModel.prototype, "day", void 0);
__decorate([
    (0, validator_1.IsArray)(),
    (0, validator_1.ArrayMinSize)(1),
    (0, validator_1.IsEnum)(AppointmentRequest_1.AppointmentDayTime, { each: true }),
    __metadata("design:type", Array)
], AppointmentDayPreferenceModel.prototype, "times", void 0);
exports.AppointmentDayPreferenceModel = AppointmentDayPreferenceModel;
class HlAppointmentRequestModel {
    constructor() {
        this.preferredDays = [];
    }
}
__decorate([
    (0, validator_1.IsArray)(),
    (0, validator_1.ArrayMinSize)(1),
    (0, validator_1.Type)(() => AppointmentDayPreferenceModel),
    (0, validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Array)
], HlAppointmentRequestModel.prototype, "preferredDays", void 0);
exports.HlAppointmentRequestModel = HlAppointmentRequestModel;
//# sourceMappingURL=HlAppointmentRequestModel.js.map